
<app-header></app-header>
<div class="confirm-body h-100">
    <div class="row h-100 w-100 justify-content-center align-items-center m-0">
      <div class="card col-sm-10 col-md-8 col-lg-8 col-xl-6 p-3 m-3">
        <div class="row mx-auto w-100 my-3 image h-30">
            <!-- <img class="mx-auto h-100" src="assets/images/confirmed-mail.png"/> -->
            <ng-lottie class="mx-auto h-100"
                [options]="options">
            </ng-lottie>
        </div>
        <div class="row my-auto">
            <div class="row mx-auto w-100 p-3 align-items-center ">
                <h3 class="mt-3 mx-auto">{{ "AUTH.CONFIRM.ADMIN_CONFIRM" | translate}}</h3>
            </div>
            <div class="mx-auto p-3">
                <div class="inner-text m-auto align-items-center">
                    <h5 class="row w-100 mx-auto p-1 align-items-center">
                        <span>{{ 'AUTH.CONFIRM.HEY' | translate }} {{currentUser?.displayName}}! </span> 
                    </h5>
                    <h5 class="row w-100 mx-auto p-1 align-items-center">
                        {{ 'AUTH.CONFIRM.VERIFY_1' | translate }}
                    </h5>
                    <h5 class="row w-100 mx-auto p-1 align-items-center">
                        {{ 'AUTH.CONFIRM.VERIFY_2' | translate }} <a class="highlight link" href="https://www.spaceil.com/" target="_blank"> {{ 'AUTH.CONFIRM.VERIFY_3' | translate }} </a>
                    </h5>
                </div>  
            </div>
        </div>
        <div class="row mx-auto p-3">
            <div class="row">
                <button type="submit" (click)="backHome()" class="btn btn-primary w-100 p-2 mx-auto submit-btn">
                    {{ 'AUTH.CONFIRM.HOME' | translate }}
                </button>
            </div>
        </div>
    </div>   
    </div>
  </div>
<!-- <app-header></app-header>
<div class="confirm-body h-100">
    <div class="row h-100 justify-content-center align-items-center">
        <div class="card col-6">
            <div class="row mx-auto image p-5">
                <img class="mx-auto" src="assets/images/space-admin-verification.png"/>
            </div>
            <div class="row mx-auto">
                <h3>{{ "AUTH.CONFIRM.ADMIN_CONFIRM" | translate}}</h3>
            </div>
            <div class="mx-auto">
                <div class="inner-text row m-auto p-5 align-items-center">
                    <h5 class="row mx-auto p-1 align-items-center">
                        <span>{{ 'AUTH.CONFIRM.HEY' | translate }} {{currentUser?.displayName}}! </span> {{ 'AUTH.CONFIRM.TO_START_ADMIN_VERIFICATION' | translate}}
                    </h5>
                </div>
                <div class="row mx-auto p-5">
                    <button type="submit" (click)="backHome()" class="btn btn-primary mx-auto w-30 submit-btn">
                        {{ 'AUTH.CONFIRM.HOME' | translate }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</div> -->
